export const RESET_CUSTOMERS = 'RESET_CUSTOMERS'
export const SET_CUSTOMERS = 'SET_CUSTOMERS'
export const SET_TYPES = 'SET_TYPES'
export const RESET_ACCOUNT_MANAGERS = 'RESET_ACCOUNT_MANAGERS'
export const SET_ACCOUNT_MANAGERS = 'SET_ACCOUNT_MANAGERS'
export const SET_EMPLOYEE_COUNTS = 'SET_EMPLOYEE_COUNTS'
export const SET_INDUSTRY_TYPES = 'SET_INDUSTRY_TYPES'
export const RESET_TYPES = 'RESET_TYPES'
export const RESET_EMPLOYEE_COUNTS = 'RESET_EMPLOYEE_COUNTS'
export const RESET_INDUSTRY_TYPES = 'RESET_INDUSTRY_TYPES'
